/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useMemo, useEffect } from "react";
import { Tab, Dropdown } from "react-bootstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import SVG from "react-inlinesvg";
import objectPath from "object-path";
import { Link } from "react-router-dom";
import { useHtmlClassService } from "../../../_core/MetronicLayout";
import { toAbsoluteUrl } from "../../../../_helpers";
import { DropdownTopbarItemToggler } from "../../../../_partials/dropdowns";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getActivities,
  getReadNotifications,
} from "../../../../../store/actions";
import moment from "moment";
import LanguageReplaceText from "../../../../../_metronic/_helpers/activityHelper";

// const perfectScrollbarOptions = {
//   wheelSpeed: 2,
//   wheelPropagation: false,
// };

export function UserNotificationsDropdown() {
  // const [key, setKey] = useState("Alerts");
  // const bgImage = toAbsoluteUrl("media/misc/bg-1.jpg");
  // const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getActivities(1));
  }, [dispatch]);

  const { activities } = useSelector((state) => state.activity);
  // const { notifications } = useSelector((state) => state.notificationTemplates);
  // const { generalSettings } = useSelector((state) => state.settings);

  const uiService = useHtmlClassService();
  // const layoutProps = useMemo(() => {
  //   return {
  //     offcanvas:
  //       objectPath.get(uiService.config, "extras.notifications.layout") ===
  //       "offcanvas",
  //   };
  // }, [uiService]);

  // const viewAll = () => {
  //   navigate(`/activities`);
  // };

  // const activity = activities
  //   ? activities?.map((act, key) => (
  //       <div className="d-flex py-4 border-bottom" key={key}>
  //         <div className="symbol symbol-40 symbol-light-primary me-5"></div>
  //         <div className="fw-bold">
  //           <span className="text-dark text-hover-primary mb-1 font-size-lg">
  //             <LanguageReplaceText
  //               languageText={act?.languageText}
  //               textToReplace={act?.textToReplace}
  //               defaultText={act?.text}
  //             />
  //           </span>
  //           <span className="text-muted d-block">
  //             {moment(act.createdAt).fromNow()}
  //           </span>
  //         </div>
  //       </div>
  //     ))
  //   : null;

  return (
    <>
      {/* {layoutProps.offcanvas && ( */}
      <div className="topbar-item">
        <Link to="/dashboard/activities">
          <div className="header-icon-btn py-2 px-3">
            <span className="svg-icon symbol">
              <SVG
                src={toAbsoluteUrl(
                  "media/svg/icons/NewDashboard/notification-icon.svg"
                )}
              />
              <i
                className="symbol-badge bg-danger top-0 end-0"
                style={{ marginTop: "2px" }}
              />
            </span>
          </div>
        </Link>
      </div>
      {/* )} */}
    </>
  );
}
